import React, { useMemo, useState } from 'react';
import { Button, notification } from 'tea-component';
import _ from 'lodash-es';
import useLanguage from '@op/hooks/useLanguage';
import { useHandleOperationParams } from './useHandleOperation';

export function useTableColumns({
  records,
  getRecordsData,
  canEditConfig, 
}: {
  records: any;
  getRecordsData: () => void;
  canEditConfig?: boolean; 
}) {
  // 编辑弹窗时的传入数据
  const { visible, params, type, handOperation, closeModal, addVersion } =
    useHandleOperationParams();

  const handleApiStatus = (status?: 'success' | 'error') => {
    if (status === 'success') {
      getRecordsData(); // 重新获取最新数据
      notification.success({ description: 'Success message prompt' });
    }
    if (status === 'error') {
      notification.error({ description: 'Failure Information Prompt' });
    }
    closeModal();
  };

  const { formatMessage } = useLanguage();

  // 当前排序列
  const [sorts, setSorts] = useState<any>();
  // 生成子孙关系信息
  const getRecordRelations = (records: any) => {
    const relations: any = {};
    const getRelations = (records: any, parentId = '') => {
      for (const record of records) {
        if (parentId) {
          relations[record.id] = parentId;
        }
        if (record.childrenList && Array.isArray(record.childrenList)) {
          record.childrenList.forEach((item: any) => {
            relations[item.id] = record.id;
            if (item.childrenList && Array.isArray(item.childrenList)) {
              getRelations(item.childrenList, item.id);
            }
          });
        }
      }
    };
    getRelations(records);

    return relations;
  };

  const relations = useMemo(() => {
    return getRecordRelations(records);
  }, [records]);

  const operationColumns = useMemo(() => {
    if (canEditConfig) {
      return [
        {
          key: 'operation',
          header: formatMessage('Operation'),
          render: ({
            id,
            version_name,
            effective_start_time,
            effective_end_time,
            white_paper,
            version_id,
            module_name,
            keywords,
            tags,
            status,
          }: any) => {
            const isVersion = !version_id;

            let params: any = {
              id,
              version_id,
              module_name,
              keywords,
              tags,
              status,
            };

            if (isVersion) {
              params = {
                id,
                version_name,
                white_paper,
                effective_start_time,
                effective_end_time,
                status,
                version_id: id, // 为了新增模块按钮
              };
            }
            const type = isVersion ? 'version' : 'module';
            return (
              <>
                <Button
                  type="link"
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    handOperation('update', type, params);
                  }}
                >
                  {formatMessage('Edit')}
                </Button>
                <Button
                  style={{ marginRight: 10 }}
                  type="link"
                  onClick={() => {
                    handOperation('delete', type, { ...params, status: 2 });
                  }}
                >
                  {formatMessage('Delete')}
                </Button>
                {isVersion && (
                  <Button
                    type="link"
                    onClick={() => {
                      handOperation('add', 'module', {
                        ...params,
                        id: undefined,
                      });
                    }}
                  >
                    {formatMessage('Add modules')}
                  </Button>
                )}
              </>
            );
          },
          width: 200,
        },
      ];
    }
    return [];
  }, [formatMessage, canEditConfig]);

  return {
    sorts,
    setSorts,
    relations,
    operationColumns,
    addVersion,
    visible,
    params,
    type,
    handleApiStatus,
    closeModal,
  };
}
